import TabNav from 'components/global/TabNav';
import FounderDocuments from 'components/views/FounderVault/_components/FounderDocuments';
import FounderFinancials from 'components/views/FounderVault/_components/FounderFinancials';
import withDismount from 'hocs/withDismount';
import { Col, Row } from 'react-bootstrap';
import { $view } from 'signals/global.signals';

const FounderVault = () => (
  <>
    <Row className="mb-16 align-items-center">
      <Col>
        <h5 className="fw-600 mb-0 text-gradient-warning-white">Data Vault</h5>
      </Col>
    </Row>
    <TabNav
      tabs={['Documents', 'Financials']}
      TabComponents={[<FounderDocuments />, <FounderFinancials />]}
      activeTab={$view.value.activeTab}
    />
  </>
);

export default withDismount(FounderVault);
